import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('ipsecTunnels', { routeName: 'frontdoorResourceRoute' })
export class IpsecTunnel extends Resource {
    id: string;
    name: string;
    frontdoorId: string;
    locationId: string;
    status: string;
    peerPublicIp: string;
    /** @deprecated first of peerCidrs, still returned so older readers keep working */
    peerCidr: string;
    peerCidrs: string[];
    // The bridge VM terminating this tunnel. publicIp is the address the customer's on-prem IPsec
    // peer connects to; privateIp is where the per-share zrok listeners bind, so it is the entry
    // point for traffic arriving over the tunnel.
    //
    // These replace nlbPrivateIp/nlbDnsName, which described the load balancer in the superseded
    // AWS Site-to-Site VPN topology. There is no load balancer in the bridge design and the
    // connector no longer populates them.
    publicIp: string;
    privateIp: string;
    region: string;
    createdAt: string;
    updatedAt: string;
    selected = false;
}
